import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { setAppBadge, clearAppBadge } from '../utils/appBadge';

/**
 * Hook to automatically sync app badge with new orders count
 * Call this hook once in your root component (e.g., App.tsx)
 */
export const useAppBadge = () => {
  const newOrdersCount = useSelector((state: RootState) => state.allOrderManagement.newOrdersCount);

  useEffect(() => {
    // Update badge whenever new orders count changes
    if (newOrdersCount > 0) {
      setAppBadge(newOrdersCount);
    } else {
      clearAppBadge();
    }
  }, [newOrdersCount]);

  // Clear badge when app is focused (user is actively using the app)
  useEffect(() => {
    const handleFocus = () => {
      // Optionally clear badge when user focuses the app
      // Uncomment if you want this behavior:
      // clearAppBadge();
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, []);
};
